import React, { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { Breadcrumb } from '@themesberg/react-bootstrap'
import { ChargeUserTable } from './partials/ChargeUserTable'
import { WhitelistIpTable } from './partials/WhitelistIpTable'
import { CurrentIpCard } from './partials/CurrentIpCard'
import { isSuperAdminUser } from '../../../../helper/adminSession'

export default () => {
  const isSuperAdmin = isSuperAdminUser()
  const [currentIp, setCurrentIp] = useState('')

  const onIpLoaded = useCallback((ip) => {
    setCurrentIp(ip || '')
  }, [])

  useEffect(() => {
    document.title = 'Cài đặt nạp tiền'
  }, [])

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: 'breadcrumb-dark breadcrumb-transparent' }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Nạp tiền</Breadcrumb.Item>
            <Breadcrumb.Item active>Cài đặt nạp tiền</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <CurrentIpCard onIpLoaded={onIpLoaded} isSuperAdmin={isSuperAdmin} />

      {isSuperAdmin && <ChargeUserTable isSuperAdmin={isSuperAdmin} />}

      {isSuperAdmin && (
        <div className="mt-4">
          <WhitelistIpTable currentIp={currentIp} />
        </div>
      )}
    </>
  )
}
